/**
 * Created by Vladislav on 25.09.2024.
 */

Placements.ENTRIES["pastAchievements"] = {
    type: Placements.FREE_FOCUS_MAIN,
    filter: function () {
        return cleverapps.achievements.wantsPastCheck;
    },
    action: function () {
        cleverapps.achievements.checkPastFeats();
    }
};

// waits for free focus in the location, so the tutorial (priority -1000) runs first and the reward window follows it
Placements.ENTRIES["visitLocationAchievement"] = {
    priority: -1100,
    type: Placements.FREE_FOCUS_MAIN | Placements.FREE_FOCUS_OTHER,
    filter: function () {
        return Boolean(cleverapps.achievements.findVisitLocationTask());
    },
    action: function () {
        const task = cleverapps.achievements.findVisitLocationTask();
        task.complete();

        cleverapps.focusManager.display({
            focus: "AchievementRewardWindow",
            action: function (f) {
                new AchievementRewardWindow(task.config);
                cleverapps.focusManager.onceNoWindowsListener = f;
            }
        });
    }
};
